import { render } from "./GeoCodeTable.vue?vue&type=template&id=2e878ab2&scoped=true"
import script from "./GeoCodeTable.vue?vue&type=script&lang=js"
export * from "./GeoCodeTable.vue?vue&type=script&lang=js"

import "./GeoCodeTable.vue?vue&type=style&index=0&id=2e878ab2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e878ab2"]])

export default __exports__